import { ALL_REASONS_KEY } from '../text';

export const UNAVAILABILITY_FILTER_TEXT = {
	reasonSelectAriaLabel: 'Filter by reason',
	allReasonsOption: 'All reasons',
};

export const ALL_REASONS_OPTION_VALUE = ALL_REASONS_KEY;
